import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { class: "flex items-center justify-end gap-2 mb-4" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "overflow-x-auto py-2 -my-2 px-6 -mx-6" }
const _hoisted_6 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_7 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_8 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_9 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_10 = { class: "text-sm text-gray-900" }
const _hoisted_11 = { class: "text-sm text-green-800" }
const _hoisted_12 = { class: "text-sm text-gray-900" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-3"
}
const _hoisted_14 = { class: "text-sm text-gray-500" }

import { computed, onMounted, ref } from 'vue'

import RowLink from '@/components/neue/RowLink.vue'
import SmartListLinks from '@/components/neue/SmartListLinks.vue'
import { senderLabel, senderLink, WINDOW_OPTIONS } from '@/helpers/messageLog'
import api from '@/store/api'
import NewAutomationButton from '@/view/automations/NewAutomationButton.vue'

const pageSize = 25

export default {
  __name: 'SentMessageList',
  setup(__props) {

const loading = ref(true)
const days = ref(WINDOW_OPTIONS[0])
const page = ref(0)
const rows = ref([])
const hasMore = ref(false)

// Text columns shrink and truncate instead of forcing the table wider than the page.
const columns = [
  { width: 'minmax(120px, 1fr)' },
  { width: 'minmax(0, 3fr)' },
  { width: 'minmax(0, 1.2fr)' },
  { width: 'minmax(0, 1.5fr)' },
  { width: '96px' },
  { width: '96px' },
  { width: '96px' },
  { width: '96px' }
]

const canPaginate = computed(() => page.value > 0 || hasMore.value)

const sentAt = timestamp =>
  new Intl.DateTimeFormat([], {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }).format(new Date(timestamp))

const load = async () => {
  loading.value = true
  try {
    const res = await api.call(
      'GET',
      `message_logs?days=${days.value}&limit=${pageSize}&page=${page.value}`,
      {},
      { receive: false }
    )
    rows.value = res.data.data || []
    hasMore.value = rows.value.length === pageSize
  } finally {
    loading.value = false
  }
}

const setDays = value => {
  days.value = value
  page.value = 0
  load()
}

const prev = () => {
  if (page.value === 0) return
  page.value--
  load()
}

const next = () => {
  page.value++
  load()
}

onMounted(load)

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_TablistGrid = _resolveComponent("TablistGrid")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Sent messages" }, {
        right: _withCtx(() => [
          _createVNode(NewAutomationButton, { type: "message" })
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NeueWell, { class: "mb-8" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Every message blast your automations and drop reminders sent, with delivery results straight from your text provider. Click a send to see how it went for each customer. ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WINDOW_OPTIONS), (option) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: option,
                  class: _normalizeClass(["rounded-full border px-3 py-1.5 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500", 
                days.value === option
                  ? 'border-gray-900 bg-gray-900 text-white'
                  : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
              ]),
                  onClick: $event => (setDays(option))
                }, " Last " + _toDisplayString(option) + " days ", 11, _hoisted_3))
              }), 128))
            ]),
            (rows.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_NeueTablist, null, {
                      head: _withCtx(() => [
                        _createVNode(_component_TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_TablistGrid, {
                              columns: columns,
                              header: ""
                            }, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("div", null, "Sent", -1),
                                _createElementVNode("div", null, "Message", -1),
                                _createElementVNode("div", null, "Sent By", -1),
                                _createElementVNode("div", null, "Smart Lists", -1),
                                _createElementVNode("div", null, "Recipients", -1),
                                _createElementVNode("div", null, "Delivered", -1),
                                _createElementVNode("div", null, "Failed", -1),
                                _createElementVNode("div", null, "Unsent", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                          return (_openBlock(), _createBlock(_component_TablistRow, {
                            key: row.id,
                            class: "cursor-pointer",
                            onClick: $event => (_ctx.$router.push('/automation/sent-messages/' + row.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TablistGrid, { columns: columns }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(sentAt(row.attributes.created_at)), 1),
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(row.attributes.body), 1),
                                  _createElementVNode("div", _hoisted_8, [
                                    _createVNode(RowLink, {
                                      to: _unref(senderLink)(row.attributes),
                                      text: _unref(senderLabel)(row.attributes)
                                    }, null, 8, ["to", "text"])
                                  ]),
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(SmartListLinks, {
                                      lists: row.attributes.audiences
                                    }, null, 8, ["lists"])
                                  ]),
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(row.attributes.recipients_count), 1),
                                  _createElementVNode("div", _hoisted_11, _toDisplayString(row.attributes.delivered_count), 1),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["text-sm", row.attributes.failed_count ? 'text-red-600' : 'text-gray-900'])
                                  }, _toDisplayString(row.attributes.failed_count), 3),
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(row.attributes.unsent_count), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  (canPaginate.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_NeueButton, {
                          disabled: page.value === 0 || loading.value,
                          onClick: prev
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("Previous", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createElementVNode("span", _hoisted_14, "Page " + _toDisplayString(page.value + 1), 1),
                        _createVNode(_component_NeueButton, {
                          disabled: !hasMore.value || loading.value,
                          onClick: next
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Next", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_NeueWell, {
                  key: 1,
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EmptyState, {
                      plural: "sent messages",
                      description: "Messages sent by your automations and drop reminders will show up here."
                    })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}